import { cn } from "@omni/utils/styles";

import { ProductFacingContainer } from "@/components/Product/ProductFacing/productFacing.container";

import { useProductPageContext } from "../../context/productPage.context";

type Props = {
    className?: string;
};

export const ProductPageFacingContainer = ({ className }: Props) => {
    const { product } = useProductPageContext();

    return (
        <ProductFacingContainer
            sku={product.sku}
            className={cn(className)}
        />
    );
};
